module.exports = __webpack_public_path__ + "img/popup3.80f242f2.png";